import { defineMessages } from 'react-intl';

import ListingSelectionEdit from './ListingSelectionEdit';
import ListingSelectionView from './ListingSelectionView';
import { listingSelectionSchema } from './schema';

import listingBlockSVG from '@plone/volto/icons/content-listing.svg';

defineMessages({
  cards: {
    id: 'Listing with selection',
    defaultMessage: 'Listing with selection',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.listingSelectionBlock = {
    id: 'listingSelectionBlock',
    title: 'Listing with selection',
    group: 'listing',
    icon: listingBlockSVG,
    view: ListingSelectionView,
    edit: ListingSelectionEdit,
    blockSchema: listingSelectionSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
